import { useLayer, useHover, Arrow } from "react-laag";
import styled from "styled-components";
import React from "react";
import Link from "../Link";
// import { between } from "polished";
// import { mediaBreakpointDown } from "../../utils";

export const TooltipDiv = styled.div`
  padding: 15px 20px;
  background: #fff;
  width: 400px;
  border-radius: 5px;
  position: relative;
  border-color: #eee;
  z-index: 999;
  box-shadow:	0 0.125rem 0.5rem rgba(0, 0, 0, .3), 0 0.0625rem 0.125rem rgba(0, 0, 0, .2);
  font-family: Poppins, Helvetica, Arial, sans-serif;

  h1 {
    font-size: 20px;
    margin: 0;
    color: #e01efe;
    font-family: Poppins, Helvetica, Arial, sans-serif;

  }
  p {
    font-size: 14px;
    margin: 0;
    color: #000;
    font-family: Poppins, Helvetica, Arial, sans-serif;

  }
  img {
    border-radius: 50%;
	border: 5px solid rgba(224,30,254,0.30);
	width: 50px;
	height: 50px;
  }

  a {
    color: #e01efe;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    max-width: 300px;
  }
`;

const Role = styled.p`
  margin: 15px 0;
`;
export const TooltipSpan = styled.span`
  display: flex;
  align-items: center;
  > div {
    display: flex;
  }
`;

const AuthorData = styled.div`
  display: flex;
  margin: 10px 0;
    align-items:flex-start;
  justify-content:center;

  > img {
    object-fit: cover !important;
  }
`
const NameAndRoleInfo = styled.div`
  margin-left: 10px;
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:center;
  width: 400px;
`

export default function InPostTooltip({ children, name, role, expertise, description, isOpen, setIsOpen, authorsPage, avatar }) {
  // const [isOver, hoverProps] = useHover();

  const { triggerProps, layerProps, arrowProps, renderLayer } = useLayer({
    isOpen: isOpen,
    containerOffset: 10,
    arrowOffset: 5,
    triggerOffset: 10,
    auto: true,
    onOutsideClick: () => (setIsOpen(false))
  });

  return (
    <>
      <TooltipSpan {...triggerProps}>
        {children}
      </TooltipSpan>
      {isOpen &&
        renderLayer(
          <TooltipDiv className="tooltip" {...layerProps}>
            <div>

              <AuthorData>
                <img src={avatar} />
                <NameAndRoleInfo>
                  <h1>{name}</h1>
                  <p style={{ margin: "5px 0", fontWeight: "600" }}>{role}</p>
                  <p>{expertise}</p>
                </NameAndRoleInfo>
              </AuthorData>


              <p>{description.slice(0, 150)}...</p>
              <div style={{ width: "100%", textAlign: "right" }}>
                <Link to={authorsPage}>Learn more</Link>
              </div>
            </div>
            <Arrow backgroundColor="#fff" borderWidth={1} borderColor={"#eee"} {...arrowProps} />
          </TooltipDiv>
        )}
    </>
  );
}